// Copyright (c) 2018 Deere & Company

import MeasurementReading from './measurement-reading';
import t from 'tcomb';

const LatestPerUnitMeasurements = t.list(MeasurementReading, 'LatestPerUnitMeasurements');

export const getDefaultState = () => new LatestPerUnitMeasurements([]);

export default LatestPerUnitMeasurements;
